/* eslint-disable @typescript-eslint/camelcase */
import Apis from 'apis';
import { objToQueryString } from 'utils/helpers';

export const api = Apis({});

interface QueryProps {
  limit?: number | string;
  offset?: number | string;
  search?: string;
}

export default {
  getContextAuditLogs: (
    query: QueryProps,
    resource?: string,
    resource_uuid?: string,
    action?: string
  ) =>
    `/analytics/audit-logs/?${objToQueryString(query)}&action=${
      action === 'all' ? '' : action
    }&resource=${resource}&resource_uuid=${resource_uuid}`,
  getAuditLogs: (query: QueryProps) =>
    `/analytics/audit-logs/?${objToQueryString(query)}`,
};
